module.exports = __webpack_public_path__ + "img/remove-ads-plus.9dc4fdf4.png";